import React, { useEffect, useState } from "react";
import styles from "./beneficiaryModal.module.css";
import {
  TextField,
  MenuItem,
  Button,
  InputAdornment,
  Switch,
  Tooltip,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useAllProduct } from "../../api-context/commonApiContext";
import config from "../../service/config";
import axios from "axios";

const BeneficiaryModal = ({
  onClose,
  setBeneficiaryAdded,
  setSuccessMsg,
  setRefreshData,
  selectedRowVal = {},
}) => {
  const {
    loggedBy,
    collectsEnabled,
    payoutsEnabled,
    userId,
    selectedCompanyName,
    selectedEscrowName,
  } = useAllProduct();
  const { clientId, setLoading, loading } = useAllProduct();
  const [collectsEnabledDetail, setCollectsEnabledDetails] = useState(false);
  const [payoutsEnabledDetail, setPayoutsEnabledDetails] = useState(false);

  const [beneficiaryName, setBeneficiaryName] = useState(
    selectedRowVal.name || ""
  );
  const [errors, setErrors] = useState({});

  const [nickname, setNickname] = useState(selectedRowVal.nickname || "");
  const [upiValue, setUpiValue] = useState(selectedRowVal?.upi_id || "");
  const [ifscValue, setIfscValue] = useState(selectedRowVal.ifsc || "");
  const [accountType, setAccountType] = useState(
    selectedRowVal.upi_id?.includes("@") ? "UPI ID" : "Bank Ac"
  );
  const [isVerified, setIsVerified] = useState(false);
  const [accountNumber, setAccountNumber] = useState(
    selectedRowVal.upi_id?.includes("@")
      ? ""
      : selectedRowVal.account_number || ""
  );
  const [verificationError, setVerificationError] = useState("");

  useEffect(() => {
    setIsVerified(false);
    setVerificationError("");
  }, [upiValue, ifscValue, accountNumber, accountType]);

  useEffect(() => {
    if (!selectedRowVal?.id) {
      // Only clear fields in "Add" mode (not Edit)
      setErrors({});
      setAccountNumber("");
      setIfscValue("");
      setUpiValue("");
    }
  }, [accountType]);

  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "beneficiaryName":
        if (!value.trim()) error = "Beneficiary name is required.";
        break;
      case "accountNumber":
        if (accountType === "Bank Ac" && !/^\d{9,18}$/.test(value))
          error = "Enter valid Account Number.";
        break;
      case "upiValue":
        if (accountType === "UPI ID" && !/^[\w.-]+@[\w.-]+$/.test(value))
          error = "Enter valid UPI ID.";
        break;
      case "ifscValue":
        if (accountType === "Bank Ac" && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value))
          error = "Enter valid IFSC code.";
        break;
      case "nickname":
        if (!value.trim()) error = "Nickname is required.";
        break;
      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
    return error;
  };

  const validateAll = () => {
    const newErrors = {};
    newErrors.beneficiaryName = validateField(
      "beneficiaryName",
      beneficiaryName
    );
    if (accountType === "Bank Ac") {
      newErrors.accountNumber = validateField("accountNumber", accountNumber);
      newErrors.ifscValue = validateField("ifscValue", ifscValue);
    } else {
      newErrors.upiValue = validateField("upiValue", upiValue);
    }
    newErrors.nickname = validateField("nickname", nickname);

    const hasError = Object.values(newErrors).some((e) => e);
    return !hasError;
  };

  const handleSubmit = async () => {
    if (!validateAll()) return;

    const payload = {
      clientId,
      beneficiaryName,
      accountType,
      upiValue,
      accountNumber,
      ifscValue,
      nickname,
      collects_enabled: collectsEnabledDetail,
      payouts_enabled: payoutsEnabledDetail,
      createdByUserId: userId,
      selectedCompanyName,
      selectedEscrowName,
      status: "Verified",
    };

    try {
      let result;
      if (selectedRowVal?.id) {
        const res = await fetch(
          `${config.node_api_endpoint}/api/beneficiaries/${selectedRowVal.id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": process.env.REACT_APP_API_KEY,
            },
            body: JSON.stringify(payload),
          }
        );
        result = await res.json();
      } else {
        const res = await fetch(
          `${config.node_api_endpoint}/api/beneficiaries`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": process.env.REACT_APP_API_KEY,
            },
            body: JSON.stringify(payload),
          }
        );
        result = await res.json();
      }

      if (result.success) {
        setSuccessMsg(
          selectedRowVal?.id ? "Beneficiary updated!" : "Beneficiary added!"
        );
        setBeneficiaryAdded(true);
        setRefreshData(true);
        onClose();
      } else {
        alert(result.message || "Something went wrong.");
        setRefreshData(true);
      }
    } catch (err) {
      console.error("API error:", err);
      alert("Something went wrong.");
    }
  };

  const conditionForCollect =
    collectsEnabled === true &&
    payoutsEnabled === false &&
    (loggedBy === "bank_admin" || loggedBy === "user")
      ? false
      : collectsEnabled === false &&
        payoutsEnabled === true &&
        (loggedBy === "bank_admin" || loggedBy === "user")
      ? true
      : collectsEnabled === true &&
        payoutsEnabled === true &&
        (loggedBy === "bank_admin" || loggedBy === "user")
      ? false
      : collectsEnabled === false &&
        payoutsEnabled === false &&
        (loggedBy === "bank_admin" || loggedBy === "user")
      ? true
      : collectsEnabled === true &&
        payoutsEnabled === false &&
        loggedBy === "client"
      ? true
      : collectsEnabled === false &&
        payoutsEnabled === true &&
        loggedBy === "client"
      ? false
      : collectsEnabled === true &&
        payoutsEnabled === true &&
        loggedBy === "client"
      ? true
      : collectsEnabled === false &&
        payoutsEnabled === false &&
        loggedBy === "client"
      ? false
      : "";

  const conditionForPayout =
    collectsEnabled === true &&
    payoutsEnabled === false &&
    (loggedBy === "bank_admin" || loggedBy === "user")
      ? true
      : collectsEnabled === false &&
        payoutsEnabled === true &&
        (loggedBy === "bank_admin" || loggedBy === "user")
      ? false
      : collectsEnabled === true &&
        payoutsEnabled === true &&
        (loggedBy === "bank_admin" || loggedBy === "user")
      ? false
      : collectsEnabled === false &&
        payoutsEnabled === false &&
        (loggedBy === "bank_admin" || loggedBy === "user")
      ? true
      : collectsEnabled === true &&
        payoutsEnabled === false &&
        loggedBy === "client"
      ? false
      : collectsEnabled === false &&
        payoutsEnabled === true &&
        loggedBy === "client"
      ? true
      : collectsEnabled === true &&
        payoutsEnabled === true &&
        loggedBy === "client"
      ? true
      : collectsEnabled === false &&
        payoutsEnabled === false &&
        loggedBy === "client"
      ? false
      : "";

  const verifyId = async (type) => {
    try {
      setLoading(true); // Start loader

      const beneficiaryId =
        type === "upi" ? upiValue : type === "ifsc" ? ifscValue : "";

      const response = await axios.post(
        `${config.node_api_endpoint}/api/verify-beneficiaries-id`,
        {
          beneficiaryId,
          type,
          accountNumber,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
        }
      );

      const result = response.data.status;

      console.log("✅ Verification success:", result);

      const isValid =
        result?.verified === true || result?.toLowerCase() === "available";

      setIsVerified(isValid);
      setVerificationError(
        isValid ? "" : "Verification failed. Please check and try again."
      );
    } catch (error) {
      console.error(
        "❌ Verification failed:",
        error.response?.data || error.message
      );
      setIsVerified(false);
      setVerificationError("Verification failed. Please try again.");
    } finally {
      setLoading(false); // Always stop loader
    }
  };

  console.log("data-->", collectsEnabled, payoutsEnabled, loggedBy);

  return (
    <div className={styles.modalBackdrop}>
      <div className={styles.modalContainer}>
        <div className="d-flex gap-2">
          <div style={{ cursor: "pointer" }} onClick={onClose}>
            &#x2190;
          </div>
          <button className={styles.backButton}>Add Beneficiary Details</button>
        </div>

        <div className={styles.toggleRow}>
          <span>Collects</span>
          <Switch
            checked={collectsEnabledDetail}
            onChange={(e) => setCollectsEnabledDetails(e.target.checked)}
            disabled={conditionForCollect}
            sx={{
              "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.12,
                cursor: "not-allowed",
                pointerEvents: "all",
              },
              "&.Mui-disabled": {
                cursor: "not-allowed",
                pointerEvents: "all",
              },
            }}
          />
          <span>Payouts</span>
          <Switch
            checked={payoutsEnabledDetail}
            onChange={(e) => setPayoutsEnabledDetails(e.target.checked)}
            disabled={conditionForPayout}
          />
        </div>

        <TextField
          label="Beneficiary Name"
          variant="outlined"
          fullWidth
          margin="normal"
          name="beneficiaryName"
          value={beneficiaryName}
          onChange={(e) => {
            setBeneficiaryName(e.target.value);
            validateField("beneficiaryName", e.target.value);
          }}
          error={!!errors.beneficiaryName}
          helperText={errors.beneficiaryName}
        />

        <TextField
          label="Select UPI ID / Bank Ac"
          select
          fullWidth
          margin="normal"
          value={accountType}
          onChange={(e) => {
            setAccountType(e.target.value);
          }}
          error={!!errors.accountType}
          helperText={errors.accountType}
        >
          <MenuItem value="UPI ID">UPI ID</MenuItem>
          <MenuItem value="Bank Ac">Bank A/C</MenuItem>
        </TextField>

        {accountType === "Bank Ac" && (
          <TextField
            label="Account Number"
            variant="outlined"
            fullWidth
            margin="normal"
            name="accountNumber"
            value={accountNumber}
            onChange={(e) => {
              setAccountNumber(e.target.value);
              validateField("accountNumber", e.target.value);
            }}
            error={!!errors.accountNumber}
            helperText={errors.accountNumber}
          />
        )}

        {accountType === "UPI ID" ? (
          <div className={`${styles.upiInputGroup} mt-3`}>
            <TextField
              label="UPI ID"
              variant="outlined"
              fullWidth
              value={upiValue}
              onChange={(e) => {
                setUpiValue(e.target.value);
                validateField("upiValue", e.target.value);
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {isVerified ? (
                      <CheckCircleIcon style={{ color: "green" }} />
                    ) : null}
                  </InputAdornment>
                ),
              }}
              error={!!errors.upiValue}
              helperText={errors.upiValue}
            />
            <Button
              variant="contained"
              className={styles.verifyButton}
              // onClick={() => setIsVerified(true)}
              onClick={() => verifyId("upi")}
            >
              Verify
            </Button>
          </div>
        ) : (
          <div className={`${styles.upiInputGroup} mt-3`}>
            <TextField
              label="IFSC"
              variant="outlined"
              fullWidth
              value={ifscValue}
              onChange={(e) => {
                setIfscValue(e.target.value);
                validateField("ifscValue", e.target.value);
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {isVerified ? (
                      <CheckCircleIcon style={{ color: "green" }} />
                    ) : null}
                  </InputAdornment>
                ),
              }}
              error={!!errors.ifscValue}
              helperText={errors.ifscValue}
            />
            <Button
              variant="contained"
              className={styles.verifyButton}
              // onClick={() => setIsVerified(true)}
              onClick={() => verifyId("ifsc")}
            >
              Verify
            </Button>
          </div>
        )}
        {!isVerified && verificationError && accountType === "UPI ID" && (
          <div className={styles.errorText}>{verificationError}</div>
        )}
        {!isVerified && verificationError && accountType === "Bank Ac" && (
          <div className={styles.errorText}>{verificationError}</div>
        )}

        <TextField
          label="Nick Name"
          variant="outlined"
          fullWidth
          margin="normal"
          name="nickname"
          value={nickname}
          onChange={(e) => {
            setNickname(e.target.value);
            validateField("nickname", e.target.value);
          }}
          error={!!errors.nickname}
          helperText={errors.nickname}
        />

        <Tooltip
          title={
            accountType === "UPI ID" && !isVerified
              ? "Please verify the UPI ID first"
              : accountType === "Bank Ac" &&
                (!isVerified || !ifscValue || !accountNumber)
              ? "Please verify the bank details first"
              : ""
          }
          disableHoverListener={
            !(accountType === "UPI ID" && !isVerified) &&
            !(
              accountType === "Bank Ac" &&
              (!isVerified || !ifscValue || !accountNumber)
            )
          }
          arrow
        >
          <div>
            <button
              type="button"
              className={`${styles.submitButton}`}
              onClick={handleSubmit}
              disabled={
                (accountType === "UPI ID" && !isVerified) ||
                (accountType === "Bank Ac" &&
                  (!isVerified || !ifscValue || !accountNumber))
              }
            >
              Submit
            </button>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default BeneficiaryModal;
